import { useSelector } from 'react-redux';
import Login from '../views/Login'

export const PrivateRoute = ({ component: RouteComponent }) => {

    const auth = useSelector((state) => state.auth);

    if (auth.status == 'authenticated') {
        return <RouteComponent />
    } else {
        return <Login />
    }
    
}